import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import TextFeild from "../../components/CommonComponents/TextFeild";
import { INPUT_LABELS } from "../../constants/lang";
import StyledSignup from "./StyledSignup";

const BasicInformation = ({ control, errors }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = (e) => {
    setShowPassword(e);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <StyledSignup>
      <Box>
        <Typography className='step-header'>Basic Information</Typography>
      </Box>
      <Box className='signup-textfeilds'>
        <Box className='signup-store'>
          <Box className='text-feilds'>
            <Controller
              name='sellerName'
              control={control}
              render={({ field, fieldState }) => (
                <TextFeild
                  {...field}
                  id='sellerName'
                  required
                  label={INPUT_LABELS.sellerName}
                  placeholder='Enter your full name'
                  variant='outlined'
                  fullWidth
                  margin='normal'
                  error={!!errors.sellerName}
                  helperText={errors.sellerName?.message}
                />
              )}
            />
          </Box>
          <Box className='text-feilds'>
            <Controller
              name='brandName'
              control={control}
              defaultValue=''
              render={({ field }) => (
                <TextFeild
                  {...field}
                  id='brandName'
                  required
                  label={INPUT_LABELS.brandName}
                  placeholder='Enter your brand name'
                  variant='outlined'
                  fullWidth
                  margin='normal'
                  error={!!errors.brandName}
                  helperText={errors.brandName?.message}
                />
              )}
            />
          </Box>
        </Box>
        <Box className='signup-store'>
          <Box className='text-feilds'>
            <Controller
              name='businessName'
              control={control}
              defaultValue=''
              render={({ field }) => (
                <TextFeild
                  {...field}
                  id='businessName'
                  required
                  label={INPUT_LABELS.businessName}
                  placeholder='Enter your business name'
                  variant='outlined'
                  fullWidth
                  margin='normal'
                  error={!!errors.businessName}
                  helperText={errors.businessName?.message}
                />
              )}
            />
          </Box>
          <Box className='text-feilds'>
            <Controller
              name='website'
              control={control}
              defaultValue=''
              render={({ field }) => (
                <TextFeild
                  {...field}
                  id='website'
                  required
                  label={INPUT_LABELS.website}
                  placeholder='Enter your website'
                  variant='outlined'
                  fullWidth
                  margin='normal'
                  error={!!errors.website}
                  helperText={errors.website?.message}
                />
              )}
            />
          </Box>
        </Box>

        <Box className='signup-email'>
          <Box className='text-feilds'>
            <Controller
              name='emailAddress'
              control={control}
              defaultValue=''
              render={({ field }) => (
                <TextFeild
                  {...field}
                  id='emailAddress'
                  required
                  label={INPUT_LABELS.emailAddress}
                  placeholder='Enter your email'
                  variant='outlined'
                  fullWidth
                  margin='normal'
                  error={!!errors.emailAddress}
                  helperText={errors.emailAddress?.message}
                />
              )}
            />
          </Box>
          <Box className='text-feilds'>
            <Controller
              name='password'
              control={control}
              defaultValue=''
              render={({ field }) => (
                <TextFeild
                  {...field}
                  required
                  id='password'
                  type='password'
                  label={INPUT_LABELS.newPassword}
                  placeholder='Enter your password'
                  variant='outlined'
                  fullWidth
                  margin='normal'
                  show={showPassword}
                  isShow={handleShowPassword}
                  error={!!errors.password}
                  helperText={errors.password?.message}
                />
              )}
            />
          </Box>
        </Box>
      </Box>
    </StyledSignup>
  );
};

export default BasicInformation;
